<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-center">
            <img class="logo_sportips" src="https://sportips.fr/images/Sportips_Logo_Horizontal_RVB.png" alt="" />
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="pa-4 rounded elevation-1 bg-grey_1">
            <p class="text-center">
              Votre demande de transfert d'inscription est validée.<br />
              Vous allez recevoir un mail de confirmation de commande ainsi que vos billets dans quelques instants
              (pensez à vérifier vos spams)
            </p>

            <div v-if="has_accueil_qrcode && urls_billets && urls_billets.length > 0">
              <div class="mb-3">
                <p class="text-center">Vous pouvez aussi télécharger votre billet en cliquant sur le lien ci-dessous :
                </p>
                <div class="d-flex justify-center gap">
                  <a v-for="(link_ticket, index) in urls_billets" :key="index"
                    :href="'https://sportips.fr/api/v2/endpoints/billet/get.php?id_inscription=' + link_ticket.id_inscription"
                    target="_blank"><v-btn color="primary-dark">{{ link_ticket.recipient }}</v-btn></a>
                </div>
                <v-divider></v-divider>
              </div>
            </div>

            <div class="d-flex justify-center gap">
              <router-link :to="{ name: 'FicheCoureur' }"><v-btn variant="outlined" color="primary-dark">Accèder ma
                  fiche</v-btn></router-link>
              <router-link :to="{ name: 'Home' }"><v-btn color="primary-dark">Retour à l'accueil</v-btn></router-link>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import UserService from '@/services/user.service';

export default {
  data() {
    return {
      transaction: {},
      order_id: "",
      urls_billets: [],
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    has_accueil_qrcode() {
      return this.mainStore.module.has_accueil_qr_code;
    },
  },
  async created() {
    if (!this.bookingStore.id_module) {
      this.$router.push({ name: "Home" });
    }

    if (this.bookingStore.transaction) {
      this.transaction = JSON.parse(JSON.stringify(this.bookingStore.transaction));
    }
    this.urls_billets = await UserService.getUrlsBillets(this.transaction);
    this.bookingStore.clearState();
  },
};
</script>

<style lang="scss" scoped></style>